"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
exports.CardColumns = styled_1.default("div")(({ children, theme, columns }) => {
    columns = columns === undefined ? React.Children.count(children) : columns;
    return {
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gridGap: theme.space.element,
    };
});
exports.default = exports.CardColumns;
//# sourceMappingURL=CardColumns.js.map